import { useState } from 'react';

const STORAGE_KEY = 'filterPreferences';

type UserPreferences = {
  [key: string]: Record<string, any>;
}

const getStoredPreferences = () => {
  const stored = localStorage.getItem(STORAGE_KEY);
  return stored ? JSON.parse(stored) : {};
};

const savePreference = (muid: string, preference: Record<string, any>) => {
  const preferences = getStoredPreferences();
  preferences[muid] = { ...preferences[muid], ...preference };
  localStorage.setItem(STORAGE_KEY, JSON.stringify(preferences));
};

const getUserPreference = (muid: string) => {
  const preferences = getStoredPreferences();
  return preferences[muid] || {};
};

const useUserPreferences = (muid: string) => {
  const [preferences, setPreferences] = useState(getUserPreference(muid));

  const updatePreference = (newPreferences: Record<string, any>) => {
    savePreference(muid, newPreferences);
    setPreferences((prev: UserPreferences) => ({ ...prev, ...newPreferences }));
  };

  return { preferences, updatePreference };
};

export default useUserPreferences;
